<!--
    描述：新增、编辑组织弹框等
    时间：2020-04-22
    Created by yefan
-->
<template>
    <div class="">
        <el-form :model="deptForm" :rules="deptRules" ref="deptForm" label-width="100px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="部门名称" prop="sname" :show-message="false">
                        <el-input v-model="deptForm.sname" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="上级部门" prop="parentName">
                        <el-input v-model="deptForm.parentName" autocomplete="off" disabled
                                  :show-message="false"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="排序" prop="sort">
                        <el-input v-model="deptForm.sort" autocomplete="off"
                                  :show-message="false"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="标签" prop="tag">
                        <el-input v-model="deptForm.tag" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
    import {insertSysDept, getDeptInfo} from '@/api/modules/sys.js'

    export default {
        props: {
            deptInfo: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            mode: {
                type: String,
                default: () => {
                    return ''
                }
            }
        },
        data() {
            return {
                deptForm: {
                    sname: '',
                    parentId: '',
                    parentName: '',
                    sort: '',
                    tag: '',
                },
                deptRules: {
                    sname: [{required: true}],
                },
            }
        },
        methods: {
            //点击确定按钮事件
            doSave() {
                this.$refs.deptForm.validate((valid) => {
                    if (valid) {
                        insertSysDept(this.deptForm).then(res => {
                            res.code == 0 ? this.$message.success("保存成功！") : this.$message.error(res.msg);
                            //点击确定后关闭弹框
                            this.$emit('dialogClose')
                        });
                    } else {
                        this.$message.warning("请完善必填项!");
                    }
                });
            },
            // 查看、编辑初始渲染数据
            initSysDept() {
                let param = {};
                param.id = this.deptInfo.id;
                getDeptInfo(param).then(res => {
                    this.deptForm = res.data;
                }).catch(err => {
                })
            }
        },
        created() {
            this.deptForm.parentId = (this.deptInfo) ? this.deptInfo.id : "0";
            this.deptForm.parentName = (this.deptInfo) ? this.deptInfo.sname : "";
            if (this.mode === 'edit') this.initSysDept();
        },
    }
</script>

<style scoped lang="less">
</style>
